import { DateTime } from "luxon";
import { extendedColors, sysColors } from "@/assets/theme/colors";

const TOPIC_PALETTE = [
  sysColors["sys-brand-primary"],
  sysColors["sys-brand-secondary"],
  sysColors["sys-brand-tertiary"],
  extendedColors["extended-success-brand-color"],
  sysColors["sys-brand-error"],
  extendedColors["extended-pganavy-brand-color-bright"],
  extendedColors["extended-pganavy-brand-color"],
  sysColors["sys-brand-primary-fixed-dim"],
  sysColors["sys-brand-secondary-fixed-dim"],
  sysColors["sys-brand-tertiary-fixed-dim"]
];

/** Stable color per topic name so series keep their color across filter changes. */
export function colorForTopic(topic: string): string {
  let hash = 0;
  for (let index = 0; index < topic.length; index += 1) {
    hash = (hash * 31 + topic.charCodeAt(index)) >>> 0;
  }
  return TOPIC_PALETTE[hash % TOPIC_PALETTE.length];
}

export function formatCount(value?: number | null): string {
  return (value ?? 0).toLocaleString("en-US");
}

export function formatPercent(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

export function percentOf(part: number, whole: number): number {
  if (whole <= 0) return 0;
  return part / whole;
}

export function formatDuration(totalSeconds?: number | null): string {
  if (totalSeconds == null) return "—";
  const rounded = Math.round(totalSeconds);
  const minutes = Math.floor(rounded / 60);
  const seconds = rounded % 60;
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
}

export function formatTotalDuration(totalSeconds?: number | null): string {
  if (totalSeconds == null) return "—";
  const rounded = Math.round(totalSeconds);
  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes.toString().padStart(2, "0")}m`;
}

export function formatDayLabel(isoDate: string): string {
  const parsed = DateTime.fromISO(isoDate);
  if (!parsed.isValid) return isoDate;
  return parsed.toFormat("MMM d");
}

/**
 * Join AI bullets into a markdown list. Newlines inside a bullet collapse to
 * spaces so one bullet cannot break out of its list item (AiCard renders
 * markdown without a sanitizer).
 */
export function toMarkdownBulletList(bullets: string[]): string {
  return bullets.map((bullet) => `- ${bullet.replace(/\s*\n+\s*/g, " ").trim()}`).join("\n");
}
